import * as Sentry from "@sentry/react";

Sentry.init({
  dsn:
    import.meta.env.VITE_SENTRY_DSN ||
    "https://41f80c16688035870b03dc324229d1ed@o4509854140727296.ingest.de.sentry.io/4509854142300240",

  enabled: import.meta.env.PROD,

  environment:
    import.meta.env.VITE_SENTRY_ENVIRONMENT ||
    import.meta.env.MODE ||
    "development",

  // Set at build time from $GITHUB_SHA so source-map uploads (via
  // sentryVitePlugin in vite.config.ts) line up with the right release.
  // Falls back to undefined in local dev, which is fine — Sentry just won't
  // group by release.
  release: import.meta.env.VITE_SENTRY_RELEASE || undefined,

  tracesSampleRate: parseFloat(
    import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || "1.0",
  ),

  debug: import.meta.env.VITE_SENTRY_DEBUG === "true",

  replaysOnErrorSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,

  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
      networkDetailAllowUrls: [window.location.origin],
    }),
    Sentry.browserTracingIntegration({
      enableInp: true,
    }),
  ],

  tracePropagationTargets: [
    "localhost",
    /^https:\/\/api\./,
    /\.stockline\.net$/,
    /\.stockline\.ai$/,
  ],

  beforeSend(event, hint) {
    if (import.meta.env.PROD) {
      const error = hint.originalException;
      if (error && typeof error === "object" && "message" in error) {
        const message = error.message as string;
        if (
          message.includes("NetworkError") ||
          message.includes("Failed to fetch")
        ) {
          return null;
        }
        if (message.includes("ResizeObserver")) {
          return null;
        }
      }
    }
    return event;
  },
});
